import { jsx, jsxs } from 'react/jsx-runtime';
import { useId } from 'react';
import { Input } from '../../Input/Input.es.js';
import { TruncatedText } from '../../TruncatedText/TruncatedText.es.js';
import { useCopyToClipboardContext } from '../CopyToClipboard.Context/index.es.js';
import { CopyToClipboardTooltip } from '../CopyToClipboard.Tooltip/CopyToClipboard.Tooltip.es.js';

const CopyToClipboardInput = ()=>{
    const [{ label, locale, message, truncatedText, isCopied }, { handleCopyClick }] = useCopyToClipboardContext();
    const ariaLabelId = useId();
    return jsx(Input, {
        label: label,
        message: message,
        children: jsxs(CopyToClipboardTooltip, {
            children: [
                jsx("span", {
                    className: "sr-only",
                    id: ariaLabelId,
                    children: `${label ?? ''} ${locale.beforeCopy} ${truncatedText}`
                }),
                jsxs(Input.Field.Button, {
                    "aria-labelledby": ariaLabelId,
                    onClick: handleCopyClick,
                    children: [
                        jsx(TruncatedText, {
                            children: truncatedText
                        }),
                        jsx(Input.Inline.Icon, {
                            align: "right",
                            name: isCopied ? 'CheckOutline' : 'DuplicateOutline',
                            size: 20
                        })
                    ]
                })
            ]
        })
    });
};
CopyToClipboardInput.displayName = 'CopyToClipboard.Input';

export { CopyToClipboardInput, CopyToClipboardInput as default };
//# sourceMappingURL=CopyToClipboard.Input.es.js.map
